import React from "react"
import { ErrorMessage, Field, FieldArray } from "formik"
import CandidateAccordionItem from "../candidate-accordion/candidate-accordion-item"

import {
  candidateList,
  candidateInput,
  formField,
  formFieldError,
  buttonWithDividerContainer,
  dividerWrapper,
  divider,
  dividerButtonWrapper,
  dividerButtonIcon,
  dividerButton
} from "./tsl-candidate.module.css"

const TSLCandidate = ({ fieldName, fieldData, values, submitted, onChange, errors }) => {
  return (
    <label htmlFor={fieldName} style={{ marginTop: "15px", width: "100%" }}>
      {fieldData.type}
      {fieldData.required && <span style={{ color: "gray" }}>*</span>}
      <div
        style={{
          width: "100%",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            margin: "0 auto",
          }}
        >
          <dl
            style={{
              marginTop: "24px",
              display: "grid",
              gap: "24px",
            }}
          >
            <FieldArray name={fieldName}>
              {({ insert, remove, push }) => (
                <>
                  {values[fieldName]?.length > 0 &&
                    values[fieldName].map((user, index) => (
                      <CandidateAccordionItem
                        key={index}
                        title={
                          user.firstName
                            ? `${user.firstName} ${user.lastName}`
                            : `Kandidaat ${index + 1}`
                        }
                      >
                        {/* Kandidaat item */}
                        <div className={candidateList}>
                          {/* VOORNAAM */}
                          <div className={candidateInput}>
                            <label htmlFor={`${fieldName}.${index}.firstName`}>
                              <span>Voornaam kandidaat</span>
                              {fieldData.required && (
                                <span
                                  style={{
                                    color: "gray",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </label>
                            <Field
                              validate={(value) =>
                                fieldData.required && !value
                                  ? `Dit veld is verplicht`
                                  : undefined
                              }
                              className={formField}
                              rows={6}
                              style={{
                                width: "100%",
                                resize: "none",
                              }}
                              as="input"
                              type="text"
                              name={`${fieldName}.${index}.firstName`}
                              disabled={submitted}
                              onChange={(e) => onChange(e, index, "firstName")}
                            />
                            <ErrorMessage
                              name={`${fieldName}.${index}.firstName`}
                              component="div"
                              className={formFieldError}
                            />
                          </div>
                          {/* ACHTERNAAM */}
                          <div className={candidateInput}>
                            <label htmlFor={`${fieldName}.${index}.lastName`}>
                              <span>Achternaam kandidaat</span>
                              {fieldData.required && (
                                <span
                                  style={{
                                    color: "gray",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </label>
                            <Field
                              validate={(value) =>
                                fieldData.required && !value
                                  ? `Dit veld is verplicht`
                                  : undefined
                              }
                              className={formField}
                              rows={6}
                              style={{
                                width: "100%",
                                resize: "none",
                              }}
                              as="input"
                              type="text"
                              name={`${fieldName}.${index}.lastName`}
                              disabled={submitted}
                              onChange={(e) => onChange(e, index, "lastName")}
                            />
                            <ErrorMessage
                              name={`${fieldName}.${index}.lastName`}
                              component="div"
                              className={formFieldError}
                            />
                          </div>
                          {/* EMAIL */}
                          <div className={candidateInput}>
                            <label htmlFor={`${fieldName}.${index}.email`}>
                              <span>E-mailadres kandidaat</span>
                              {fieldData.required && (
                                <span
                                  style={{
                                    color: "gray",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </label>
                            <Field
                              validate={(value) =>
                                fieldData.required && !value
                                  ? `Dit veld is verplicht`
                                  : undefined
                              }
                              className={formField}
                              rows={6}
                              style={{
                                width: "100%",
                                resize: "none",
                              }}
                              as="input"
                              type="email"
                              name={`${fieldName}.${index}.email`}
                              disabled={submitted}
                              onChange={(e) => onChange(e, index, "email")}
                            />
                            <ErrorMessage
                              name={`${fieldName}.${index}.email`}
                              component="div"
                              className={formFieldError}
                            />
                          </div>
                          {/* Inclusief IQ-Test */}
                          <div className={candidateInput}>
                            <label
                              htmlFor={`${fieldName}.${index}.iq_test`}
                              style={{
                                marginTop: "25px",
                              }}
                            >
                              <Field
                                validate={(value) => undefined}
                                style={{
                                  height: "unset",
                                }}
                                type={"checkbox"}
                                name={`${fieldName}.${index}.iq_test`}
                                disabled={submitted}
                                onChange={(e) => onChange(e, index, "iq_test")}
                              />
                              <span>Inclusief IQ-test</span>
                            </label>
                          </div>
                          {/* Taal */}
                          <div className={candidateInput}>
                            <label htmlFor={`${fieldName}.${index}.language`}>
                              <span>Taal</span>
                              {fieldData.required && (
                                <span
                                  style={{
                                    color: "gray",
                                  }}
                                >
                                  *
                                </span>
                              )}
                            </label>
                            <Field
                              validate={(value) =>
                                fieldData.required && !value
                                  ? `Dit veld is verplicht`
                                  : undefined
                              }
                              className={formField}
                              rows={6}
                              style={{
                                width: "100%",
                                resize: "none",
                              }}
                              as="select"
                              name={`${fieldName}.${index}.language`}
                              disabled={submitted}
                              onChange={(e) => onChange(e, index, "language")}
                            >
                              <option value="">Kies een taal</option>
                              <option value="NL">Nederlands</option>
                              <option value="EN">Engels</option>
                              {/* Add more language options as needed */}
                            </Field>
                            <ErrorMessage
                              name={`${fieldName}.${index}.language`}
                              component="div"
                              className={formFieldError}
                            />
                          </div>
                        </div>
                        <div className="p-4">
                          {/* You can display more details here if needed */}
                          <button
                            type="button"
                            disabled={submitted}
                            onClick={() => remove(index)}
                          >
                            Remove
                          </button>
                        </div>
                      </CandidateAccordionItem>
                    ))}

                  <div className={buttonWithDividerContainer}>
                    <div className={dividerWrapper} aria-hidden="true">
                      <div className={divider} />
                    </div>
                    <div className={dividerButtonWrapper}>
                      <button
                        type="button"
                        className={dividerButton}
                        disabled={submitted}
                        onClick={() =>
                          push({
                            firstName: "",
                            lastName: "",
                            email: "",
                            iq_test: false,
                            language: "",
                          })
                        }
                      >
                        <svg
                          className={dividerButtonIcon}
                          version="1.1"
                          id="Capa_1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="800px"
                          height="800px"
                          viewBox="0 0 45.402 45.402"
                        >
                          <g>
                            <path
                              d="M41.267,18.557H26.832V4.134C26.832,1.851,24.99,0,22.707,0c-2.283,0-4.124,1.851-4.124,4.135v14.432H4.141
c-2.283,0-4.139,1.851-4.138,4.135c-0.001,1.141,0.46,2.187,1.207,2.934c0.748,0.749,1.78,1.222,2.92,1.222h14.453V41.27
c0,1.142,0.453,2.176,1.201,2.922c0.748,0.748,1.777,1.211,2.919,1.211c2.282,0,4.129-1.851,4.129-4.133V26.857h14.435
c2.283,0,4.134-1.867,4.133-4.15C45.399,20.425,43.548,18.557,41.267,18.557z"
                            />
                          </g>
                        </svg>
                        <span>Nieuwe kandidaat</span>
                      </button>
                    </div>
                  </div>
                </>
              )}
            </FieldArray>
            {typeof errors.usersCount === "string" && (
              <p style={{ color: "red" }}>Voeg minstens één kandidaat toe</p>
            )}
          </dl>
        </div>
      </div>
    </label>
  )
}

export default TSLCandidate
